
export function thresholdFilter(imageData, thresholdValue) {
    for (let i = 0; i < imageData.data.length; i += 4) {
        let avg = (imageData.data[i] + imageData.data[i + 1] + imageData.data[i + 2]) / 3;
        let value = avg > thresholdValue ? 255 : avg; // Black and white
        imageData.data[i] = value;
        imageData.data[i + 1] = value;
        imageData.data[i + 2] = value;
    }
}

export function invertImageFilter(imageData) {
    for (let i = 0; i < imageData.data.length; i += 4) {
        for (let j = 0; j < 3; j++) {
            imageData.data[i + j] = 255 - imageData.data[i + j];
        }
    }
}